import { render, staticRenderFns } from "./ModalExcluirTelaDescanso.vue?vue&type=template&id=22b235ee&scoped=true"
import script from "./ModalExcluirTelaDescanso.vue?vue&type=script&lang=js"
export * from "./ModalExcluirTelaDescanso.vue?vue&type=script&lang=js"
import style0 from "./ModalExcluirTelaDescanso.vue?vue&type=style&index=0&id=22b235ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b235ee",
  null
  
)

export default component.exports